import { render, staticRenderFns } from "./FlowGauge.vue?vue&type=template&id=b5c36ee2&scoped=true&"
import script from "./FlowGauge.vue?vue&type=script&lang=js&"
export * from "./FlowGauge.vue?vue&type=script&lang=js&"
import style0 from "./FlowGauge.vue?vue&type=style&index=0&id=b5c36ee2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c36ee2",
  null
  
)

export default component.exports